<template>

    <div v-loading="loading">

        <!-- 头部 -->
        <div class="top">

            <!-- 新增SKU -->
            <el-button v-if="UN == 'niushaoyun' || UN == 'ywk'" type="primary" size="mini" style="margin-right:0.5vw" @click="add_sku" icon="el-icon-plus">新增SKU</el-button>

            <!-- 请输入SKU -->
            <el-input
                size="mini"
                style="width: 150px; margin-right: 0.5vw"
                placeholder="请输入SKU"
                v-model="SKU"
                clearable>
            </el-input>

            <!-- 请输入商品名称 -->
            <el-input
                size="mini"
                style="width: 300px; margin-right: 0.5vw"
                placeholder="请输入商品名称"
                v-model="product_name"
                clearable>
            </el-input>

            <!-- 查询按钮 -->
            <el-button type="primary" size="mini" style="margin-right: 0.5vw" @click="_search" icon="el-icon-search">查询</el-button>

            <!-- 批量上传 -->
            <!-- <el-button type="primary" size="mini" style="margin-right: 0.5vw" @click="batch_upload" icon="el-icon-upload">批量上传</el-button> -->

            <!-- 重置 -->
            <!-- <el-button type="primary" size="mini" style="margin:0" @click="_refresh" icon="el-icon-refresh">重置</el-button> -->
            
        </div>
        
        <!-- 主体表格 -->
        <el-table
            :data="tableData" 
            height="79vh" 
            border 
            style="width: 100%;margin-top:1vh;border: 1px solid #000000;" 
            :cell-style="{padding:1,borderColor:'#000000'}" 
            :header-cell-style="{borderColor:'#000000',color:'#0099ff'}">

            <!-- 联赛名称 -->
            <el-table-column fixed align="center" prop="league_name" label="联赛名称" width="50vw"></el-table-column>

            <!-- 队伍名称 -->
            <el-table-column fixed align="center" prop="team_name" label="队伍名称" width="120vw"></el-table-column>

            <!-- SKU -->
            <el-table-column fixed align="center" prop="sku" label="SKU" width="150vw"></el-table-column>

            <!-- 商品名称 -->
            <el-table-column fixed align="center" prop="product_name" label="商品名称" width="250vw"></el-table-column>

            <!-- 短裤 -->
            <el-table-column align="center" prop="shorts" label="短裤" width="50vw">
                <template slot-scope="scope">
                    <strong style="font-size:24px" :style="{'color':(scope.row.shorts == '1' ? '#0dff00' : scope.row.shorts == '0' ? 'red' : scope.row.shorts == '-1' ? 'black' : '')}">{{scope.row.shorts == '1' ? '√' : (scope.row.shorts == '0' ? '×' : (scope.row.shorts == '-1' ? '-' : '???'))}}</strong>
                </template>
            </el-table-column>

            <!-- 袜子 -->
            <el-table-column align="center" prop="socks" label="袜子" width="50vw">
                <template slot-scope="scope">
                    <strong style="font-size:24px" :style="{'color':(scope.row.socks == '1' ? '#0dff00' : scope.row.socks == '0' ? 'red' : scope.row.socks == '-1' ? 'black' : '')}">{{scope.row.socks == '1' ? '√' : (scope.row.socks == '0' ? '×' : (scope.row.socks == '-1' ? '-' : '???'))}}</strong>
                </template>
            </el-table-column>

            <!-- 添加时间 -->
            <el-table-column align="center" prop="add_time" label="添加时间" width="100vw"></el-table-column>

            <!-- 添加人 -->
            <el-table-column align="center" prop="add_person" label="添加人"></el-table-column>

            <!-- 备注 -->
            <el-table-column align="center" prop="remarks" label="备注" width="80vw"></el-table-column>

            <!-- 法语站点 -->
            <el-table-column align="center" label="法语" v-if="(UN == 'zhaorui' || UN == 'wangdan' || UN == 'zhangshifan77' || UN == 'hfq' || UN == 'zmj') ? false : true">

                <!-- supermaillot -->
                <el-table-column align="center" :label="'supermaillot(' + supermaillot + ')'"  width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.supermaillot_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.supermaillot_option,'supermaillot_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.supermaillot_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.supermaillot_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'WXX') ? true : false"
                            v-model="scope.row.supermaillot_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.supermaillot_option,scope.row.hidden_time,'supermaillot_option')">
                        </el-switch>
                        <span v-show="(UN == 'WXX') ? false : true" :style="{'color':(scope.row.supermaillot_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.supermaillot_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- fortmaillot -->
                <el-table-column align="center" :label="'fortmaillot(' + fortmaillot + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                        v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.fortmaillot_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.fortmaillot_option,'fortmaillot_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.fortmaillot_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.fortmaillot_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'WXX') ? true : false"
                            v-model="scope.row.fortmaillot_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.fortmaillot_option,scope.row.hidden_time,'fortmaillot_option')">
                        </el-switch>
                        <span v-show="(UN == 'WXX') ? false : true" :style="{'color':(scope.row.fortmaillot_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.fortmaillot_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- ligafoot -->
                <el-table-column align="center" :label="'ligafoot(' + ligafoot + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.ligafoot_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.ligafoot_option,'ligafoot_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.ligafoot_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.ligafoot_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'WXX') ? true : false"
                            v-model="scope.row.ligafoot_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.ligafoot_option,scope.row.hidden_time,'ligafoot_option')">
                        </el-switch>
                        <span v-show="(UN == 'WXX') ? false : true" :style="{'color':(scope.row.ligafoot_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.ligafoot_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- maillottrade -->
                <el-table-column align="center" :label="'maillottrade(' + maillottrade + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.maillottrade_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.maillottrade_option,'maillottrade_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.maillottrade_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.maillottrade_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'WXX') ? true : false"
                            v-model="scope.row.maillottrade_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.maillottrade_option,scope.row.hidden_time,'maillottrade_option')">
                        </el-switch>
                        <span v-show="(UN == 'WXX') ? false : true" :style="{'color':(scope.row.maillottrade_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.maillottrade_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

            </el-table-column>

            <!-- 西语站点 -->
            <el-table-column align="center" label="西语" v-if="(UN == 'WXX' || UN == 'wangdan' || UN == 'zhangshifan77' || UN == 'hfq' || UN == 'zmj') ? false : true">

                <!-- madrid-shop -->
                <el-table-column align="center" :label="'madrid-shop(' + madrid_shop + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.madrid_shop_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.madrid_shop_option,'madrid_shop_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.madrid_shop_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.madrid_shop_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhaorui') ? true : false"
                            v-model="scope.row.madrid_shop_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.madrid_shop_option,scope.row.hidden_time,'madrid_shop_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhaorui') ? false : true" :style="{'color':(scope.row.madrid_shop_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.madrid_shop_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- cuirz -->
                <el-table-column align="center" :label="'cuirz(' + cuirz + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.cuirz_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.cuirz_option,'cuirz_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.cuirz_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.cuirz_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhaorui') ? true : false"
                            v-model="scope.row.cuirz_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.cuirz_option,scope.row.hidden_time,'cuirz_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhaorui') ? false : true" :style="{'color':(scope.row.cuirz_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.cuirz_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- beazl -->
                <el-table-column align="center" :label="'beazl(' + beazl + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.beazl_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.beazl_option,'beazl_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.beazl_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.beazl_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhaorui') ? true : false"
                            v-model="scope.row.beazl_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.beazl_option,scope.row.hidden_time,'beazl_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhaorui') ? false : true" :style="{'color':(scope.row.beazl_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.beazl_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

            </el-table-column>

            <!-- 英语站点 -->
            <el-table-column align="center" label="英语" v-if="(UN == 'zhaorui' || UN == 'WXX' || UN == 'zhangshifan77') ? false : true">

                <!-- kickitshirts -->
                <el-table-column align="center" :label="'kickitshirts英国(' + kickitshirts + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.kickitshirts_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.kickitshirts_option,'kickitshirts_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.kickitshirts_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.kickitshirts_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'wangdan' || UN == 'hfq') ? true : false"
                            v-model="scope.row.kickitshirts_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.kickitshirts_option,scope.row.hidden_time,'kickitshirts_option')">
                        </el-switch>
                        <span v-show="(UN == 'wangdan' || UN == 'hfq') ? false : true" :style="{'color':(scope.row.kickitshirts_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.kickitshirts_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- mailloten -->
                <el-table-column align="center" :label="'mailloten美国(' + mailloten + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.mailloten_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.mailloten_option,'mailloten_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.mailloten_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.mailloten_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'wangdan' || UN == 'niushaoyun' || UN == 'hfq' || UN == 'zmj') ? true : false"
                            v-model="scope.row.mailloten_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.mailloten_option,scope.row.hidden_time,'mailloten_option')">
                        </el-switch>
                        <span v-show="(UN == 'wangdan' || UN == 'niushaoyun' || UN == 'hfq' || UN == 'zmj') ? false : true" :style="{'color':(scope.row.mailloten_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.mailloten_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- honorjersey -->
                <el-table-column align="center" :label="'honorjersey(' + honorjersey + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.honorjersey_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.honorjersey_option,'honorjersey_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.honorjersey_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.honorjersey_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'wangdan') ? true : false"
                            v-model="scope.row.honorjersey_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.honorjersey_option,scope.row.hidden_time,'honorjersey_option')">
                        </el-switch>
                        <span v-show="(UN == 'wangdan') ? false : true" :style="{'color':(scope.row.honorjersey_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.honorjersey_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

            </el-table-column>

            <!-- 日语站点 -->
            <el-table-column align="center" label="日语" v-if="(UN == 'zhaorui' || UN == 'wangdan' || UN == 'WXX' || UN == 'hfq' || UN == 'zmj') ? false : true">

                <!-- nihonbro -->
                <el-table-column align="center" :label="'nihonbro(' + nihonbro + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.nihonbro_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.nihonbro_option,'nihonbro_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.nihonbro_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.nihonbro_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhangshifan77') ? true : false"
                            v-model="scope.row.nihonbro_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.nihonbro_option,scope.row.hidden_time,'nihonbro_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhangshifan77') ? false : true" :style="{'color':(scope.row.nihonbro_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.nihonbro_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- jleague-shop -->
                <el-table-column align="center" :label="'jleague-shop(' + jleague_shop + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.jleague_shop_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.jleague_shop_option,'jleague_shop_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.jleague_shop_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.jleague_shop_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhangshifan77') ? true : false"
                            v-model="scope.row.jleague_shop_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.jleague_shop_option,scope.row.hidden_time,'jleague_shop_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhangshifan77') ? false : true" :style="{'color':(scope.row.jleague_shop_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.jleague_shop_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

                <!-- top-w -->
                <el-table-column align="center" :label="'top-w(' + top_w + ')'" width="193vw">
                    <template slot-scope="scope">
                        <el-switch
                            v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                            v-model="scope.row.top_w_option[0]"
                            active-text="需要添加"
                            inactive-text="无需添加"
                            active-value="1"
                            inactive-value="0"
                            @change="left($event,scope.row.sku,scope.row.top_w_option,'top_w_option')">
                        </el-switch>
                        <span v-show="(UN == 'niushaoyun' || UN == 'ywk') ? false : true" :style="{'color':(scope.row.top_w_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.top_w_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                        <br>
                        <el-switch
                            v-show="(UN == 'zhangshifan77') ? true : false"
                            v-model="scope.row.top_w_option[1]"
                            active-text="已经添加"
                            inactive-text="尚未添加"
                            active-value="1"
                            inactive-value="0"
                            @change="right($event,scope.row.sku,scope.row.top_w_option,scope.row.hidden_time,'top_w_option')">
                        </el-switch>
                        <span v-show="(UN == 'zhangshifan77') ? false : true" :style="{'color':(scope.row.top_w_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.top_w_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                    </template>
                </el-table-column>

            </el-table-column>

            <!-- 意语站点 -->
            <el-table-column align="center" label="意语" v-if="(UN == 'WXX' || UN == 'zhaorui' || UN == 'wangdan' || UN == 'zhangshifan77' || UN == 'hfq' || UN == 'zmj') ? false : true">

                <!-- figocalcio -->
                <el-table-column align="center" :label="'figocalcio(' + figocalcio + ')'" width="193vw">
                    <template slot-scope="scope">
                            <el-switch
                                v-show="(UN == 'niushaoyun' || UN == 'ywk') ? true : false"
                                v-model="scope.row.figocalcio_option[0]"
                                active-text="需要添加"
                                inactive-text="无需添加"
                                active-value="1"
                                inactive-value="0"
                                @change="left($event,scope.row.sku,scope.row.figocalcio_option,'figocalcio_option')">
                            </el-switch>
                            <span v-show="(UN == 'niushaoyun') ? false : true" :style="{'color':(scope.row.figocalcio_option[0] == '1' ? 'red' : '#0dff00')}">{{scope.row.figocalcio_option[0] == '1' ? '需要添加' : '无需添加'}}</span>
                            <br>
                            <el-switch
                                v-show="(UN == 'niushaoyun' || UN == 'cw' || UN == 'jiangfei' || UN == 'hjx' || UN == 'ywk') ? false : true"
                                v-model="scope.row.figocalcio_option[1]"
                                active-text="已经添加"
                                inactive-text="尚未添加"
                                active-value="1"
                                inactive-value="0"
                                @change="right($event,scope.row.sku,scope.row.figocalcio_option,scope.row.hidden_time,'figocalcio_option')">
                            </el-switch>
                            <span v-show="(UN == 'niushaoyun' || UN == 'cw' || UN == 'jiangfei' || UN == 'hjx') ? true : false" :style="{'color':(scope.row.figocalcio_option[1] == '1' ? '#0dff00' : 'red')}">{{scope.row.figocalcio_option[1] == '1' ? '已经添加' : '尚未添加'}}</span>
                        </template>
                </el-table-column>

            </el-table-column>

            <!-- 是否优先添加 -->
            <el-table-column fixed="right" label="是否优先添加" width="55" >
              <template slot-scope="scope">
                <el-radio-group v-if="UN == 'niushaoyun'" @input='IsPriority(scope.row)' v-model="scope.row.ispriority">
                  <el-radio label="是" style="margin-bottom:10px">是</el-radio>
                  <el-radio label="">否</el-radio>
                </el-radio-group>
                <span v-else>{{scope.row.ispriority}}</span>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column fixed="right" align="center" label="操作" width="80vw" v-if="UN == 'niushaoyun' ? true : false">
                <template slot-scope="scope">
                    <el-link type="success" :underline="false" icon="el-icon-edit" @click="edit_sku(scope.$index, scope.row)">修改</el-link>
                    <el-link type="danger" :underline="false" icon="el-icon-delete" @click="delete_sku(scope.$index, scope.row)">删除</el-link>
                </template>
            </el-table-column>

        </el-table>

        <!-- 新增SKU对话框 -->
        <el-dialog title="新增SKU" :visible.sync="add_sku_dialog" width="50%">

            <span style="color:red;margin-left:5vh">温馨提示:短裤、袜子选项中 1表示:√,0表示:×,-1表示:-;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;站点选项中 11表示:需要添加并且已经添加,10表示:需要添加但是尚未添加,00表示:无需添加并且尚未添加.</span>

            <!-- form表单 -->
            <el-form style="margin-top:2vh" ref="form" :model="add_sku_form" label-width="100px" size="mini" :inline="true">

                <!-- 联赛名称 -->
                <el-form-item label="联赛名称">
                    <el-input v-model="add_sku_form.league_name" placeholder="请输入联赛名称" clearable></el-input>
                </el-form-item>

                <!-- 队伍名称 -->
                <el-form-item label="队伍名称">
                    <el-input v-model="add_sku_form.team_name" placeholder="请输入队伍名称" clearable></el-input>
                </el-form-item>

                <!-- SKU -->
                <el-form-item label="SKU">
                    <el-input v-model="add_sku_form.sku" placeholder="请输入SKU" clearable></el-input>
                </el-form-item>

                <!-- 商品名称 -->
                <el-form-item label="商品名称">
                    <el-input v-model="add_sku_form.product_name" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>

                <!-- 短裤 -->
                <el-form-item label="短裤">
                    <el-select style="width: 193px;" v-model="add_sku_form.shorts" placeholder="请选择是否添加短裤">
                        <el-option
                            v-for="item in shorts_socks"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 袜子 -->
                <el-form-item label="袜子">
                    <el-select style="width: 193px;" v-model="add_sku_form.socks" placeholder="请选择是否添加袜子">
                        <el-option
                            v-for="item in shorts_socks"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 备注 -->
                <el-form-item label="备注">
                    <el-input v-model="add_sku_form.remarks" placeholder="请输入备注" clearable></el-input>
                </el-form-item>

                <!-- supermaillot -->
                <el-form-item label="supermaillot">
                    <el-select style="width: 193px;" v-model="add_sku_form.supermaillot_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- fortmaillot -->
                <el-form-item label="fortmaillot">
                    <el-select style="width: 193px;" v-model="add_sku_form.fortmaillot_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- ligafoot -->
                <el-form-item label="ligafoot">
                    <el-select style="width: 193px;" v-model="add_sku_form.ligafoot_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- maillottrade -->
                <el-form-item label="maillottrade">
                    <el-select style="width: 193px;" v-model="add_sku_form.maillottrade_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- madrid_shop -->
                <el-form-item label="madrid_shop">
                    <el-select style="width: 193px;" v-model="add_sku_form.madrid_shop_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- cuirz -->
                <el-form-item label="cuirz">
                    <el-select style="width: 193px;" v-model="add_sku_form.cuirz_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- beazl -->
                <el-form-item label="beazl">
                    <el-select style="width: 193px;" v-model="add_sku_form.beazl_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- kickitshirts -->
                <el-form-item label="kickitshirts">
                    <el-select style="width: 193px;" v-model="add_sku_form.kickitshirts_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- mailloten -->
                <el-form-item label="mailloten">
                    <el-select style="width: 193px;" v-model="add_sku_form.mailloten_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- honorjersey -->
                <el-form-item label="honorjersey">
                    <el-select style="width: 193px;" v-model="add_sku_form.honorjersey_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- nihonbro -->
                <el-form-item label="nihonbro">
                    <el-select style="width: 193px;" v-model="add_sku_form.nihonbro_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- jleague_shop -->
                <el-form-item label="jleague_shop">
                    <el-select style="width: 193px;" v-model="add_sku_form.jleague_shop_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- top_w -->
                <el-form-item label="top_w">
                    <el-select style="width: 193px;" v-model="add_sku_form.top_w_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- figocalcio -->
                <el-form-item label="figocalcio">
                    <el-select style="width: 193px;" v-model="add_sku_form.figocalcio_option" placeholder="请选择">
                        <el-option
                            v-for="item in site_status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="add_sku_dialog = false">取 消</el-button>
                <el-button type="primary" @click="affirm_add_sku">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 修改SKU对话框 -->
        <el-dialog title="修改SKU" :visible.sync="edit_sku_dialog" width="33%" style="margin:10vh 0 0 0">
            <span style="color:red;margin-left:5vh">温馨提示:短裤、袜子选项中 1表示:√，0表示:×，-1表示:-</span>
            <el-form style="margin-top:2vh" ref="form" :model="edit_sku_form" label-width="80px" size="mini" :inline="true">

                <!-- 联赛名称 -->
                <el-form-item label="联赛名称">
                    <el-input v-model="edit_sku_form.league_name" placeholder="请输入联赛名称" clearable></el-input>
                </el-form-item>

                <!-- 队伍名称 -->
                <el-form-item label="队伍名称">
                    <el-input v-model="edit_sku_form.team_name" placeholder="请输入队伍名称" clearable></el-input>
                </el-form-item>

                <!-- SKU -->
                <el-form-item label="SKU">
                    <el-input v-model="edit_sku_form.sku" placeholder="请输入SKU" disabled style="width:10vw"></el-input>
                </el-form-item>

                <!-- 商品名称 -->
                <el-form-item label="商品名称">
                    <el-input v-model="edit_sku_form.product_name" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>

                <!-- 短裤 -->
                <el-form-item label="短裤">
                    <el-select style="width: 193px;" v-model="edit_sku_form.shorts" placeholder="请选择是否添加短裤">
                        <el-option
                            v-for="item in shorts_socks"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 袜子 -->
                <el-form-item label="袜子">
                    <el-select style="width: 193px;" v-model="edit_sku_form.socks" placeholder="请选择是否添加袜子">
                        <el-option
                            v-for="item in shorts_socks"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 备注 -->
                <el-form-item label="备注">
                    <el-input v-model="edit_sku_form.remarks" placeholder="请输入备注" clearable></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel_edit_sku">取 消</el-button>
                <el-button type="primary" @click="affirm_edit_sku">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 删除SKU对话框 -->
        <el-dialog title="删除SKU" :visible.sync="delete_sku_dialog" width="30%">
            <span>确定删除这条SKU?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delete_sku_dialog = false">取 消</el-button>
                <el-button type="primary" @click="affirm_delete_dialog">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 是否优先添加SKU对话框 -->
        <el-dialog title="是否优先添加SKU" :visible.sync="ispriority_add_sku_dialog" width="30%">
            <span>确定修改吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel_IsPriority">取 消</el-button>
                <el-button type="primary" @click="affirm_IsPriority">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 修改站点选项对话框 -->
        <el-dialog title="SKU添加状态" :visible.sync="site_option_dialog" width="30%" style="margin:0 10vw 0 0">
            <span>确定修改吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel_site_option">取 消</el-button>
                <el-button type="primary" @click="affirm_site_option">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 批量上传对话框 -->
        <!-- <el-dialog
            title="提示"
            :visible.sync="batch_upload_dialog"
            width="30%">
            <el-upload
                drag
                style="text-align: center;"
                class="upload-demo"
                :show-file-list='false'
                :on-success="uploadSuccess"
                :before-upload="beforeAvatarUpload"
                :action="uploadFile()">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传Excel表格文件</div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batch_upload_dialog = false">取 消</el-button>
                <el-button type="primary" @click="batch_upload_dialog = false">确 定</el-button>
            </span>
        </el-dialog> -->

        <!-- 分页器 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="mytsxx"
            :page-size="mrmyts"
            layout="total, sizes, prev, pager, next, jumper"
            :total="Total"
            style="display:flex; justify-content: center;">
        </el-pagination>

    </div>

</template>

<script>

import {UploadSku,DeleteSku,PriorityAddSku,SearchSku,GetSku,EditSite,GetKey,UpdateSku} from '../../api/api'

    export default {

        data(){
            return {

                // localStorage
                UN:'',
                // 页面数据绑定
                tableData: [],
                // 时间范围绑定
                time_value:'',
                // SKU绑定
                SKU:'',
                // 商品名称绑定
                product_name:'',
                // 添加人绑定
                person:'',
                // 新增SKU对话框
                add_sku_dialog:false,
                // 新增SKU表单
                add_sku_form:{
                    league_name:'',
                    team_name:'',
                    sku:'',
                    product_name:'',
                    shorts:'',
                    socks:'',
                    remarks:'',
                    supermaillot_option:'',
                    fortmaillot_option:'',
                    ligafoot_option:'',
                    maillottrade_option:'',
                    madrid_shop_option:'',
                    cuirz_option:'',
                    beazl_option:'',
                    kickitshirts_option:'',
                    mailloten_option:'',
                    honorjersey_option:'',
                    nihonbro_option:'',
                    jleague_shop_option:'',
                    top_w_option:'',
                    figocalcio_option:''
                },
                // 下拉框设置、未加站点选择项
                Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'top-w', value: 'top-w' }, { label: 'figocalcio', value: 'figocalcio' }],
                // 下拉框短裤、袜子选择项
                shorts_socks:[{ label: '1', value: '1' },{ label: '0', value: '0' },{ label: '-1', value: '-1' }],
                // 修改SKU对话框
                edit_sku_dialog:false,
                // 修改SKU表单
                edit_sku_form:{
                    league_name:'',
                    team_name:'',
                    sku:'',
                    product_name:'',
                    shorts:'',
                    socks:'',
                    remarks:''
                },
                // 加载动画
                loading:true,
                // 站点状态
                site_status:[{ label: '11', value: '11' },{ label: '10', value: '10' },{ label: '00', value: '00' }],
                // 删除SKU对话框
                delete_sku_dialog:false,
                // 删除SKU所需参数
                delete_sku_params:{},
                // 是否优先添加SKU对话框
                ispriority_add_sku_dialog:false,
                // 是否优先添加SKU所需参数
                ispriority_add_sku_params:{},
                // 修改站点选项对话框
                site_option_dialog:false,
                // 修改站点选项所需参数
                site_option_params:{},
                // 批量上传对话框
                batch_upload_dialog:false,

                // 页面默认展示哪一页
                currentPage:1,
                // 每页条数选项
                mytsxx:[5,10,20,30,50,100],
                // 设置默认每页条数
                mrmyts:10,
                // SKU总条数
                Total:0,

                supermaillot:0,
                fortmaillot:0,
                ligafoot:0,
                maillottrade:0,
                madrid_shop:0,
                cuirz:0,
                beazl:0,
                kickitshirts:0,
                mailloten:0,
                honorjersey:0,
                nihonbro:0,
                jleague_shop:0,
                top_w:0,
                figocalcio:0,

            }
        },

        created(){

            this.UN = window.localStorage.getItem('un');

            this.getSiteCount();

            var params = {
                sku:this.SKU,
                product_name:this.product_name,
                limit:this.mrmyts,
                offset:this.currentPage
            }

            SearchSku(params).then(res => {

                for(var i of res.data){
                    i.supermaillot_option = i.supermaillot_option.split('');
                    i.fortmaillot_option = i.fortmaillot_option.split('');
                    i.ligafoot_option = i.ligafoot_option.split('');
                    i.maillottrade_option = i.maillottrade_option.split('');
                    i.madrid_shop_option = i.madrid_shop_option.split('');
                    i.cuirz_option = i.cuirz_option.split('');
                    i.beazl_option = i.beazl_option.split('');
                    i.kickitshirts_option = i.kickitshirts_option.split('');
                    i.mailloten_option = i.mailloten_option.split('');
                    i.honorjersey_option = i.honorjersey_option.split('');
                    i.nihonbro_option = i.nihonbro_option.split('');
                    i.jleague_shop_option = i.jleague_shop_option.split('');
                    i.top_w_option = i.top_w_option.split('');
                    i.figocalcio_option = i.figocalcio_option.split('');
                }

                this.tableData = res.data;
                this.Total = res.count;
                this.loading = false;

            })

        },

        methods: {

            // 获取SKU
            getSku(){

                this.loading = true;

                var params = {
                    sku:this.SKU,
                    product_name:this.product_name,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }

                SearchSku(params).then(res => {

                    for(var i of res.data){
                        i.supermaillot_option = i.supermaillot_option.split('');
                        i.fortmaillot_option = i.fortmaillot_option.split('');
                        i.ligafoot_option = i.ligafoot_option.split('');
                        i.maillottrade_option = i.maillottrade_option.split('');
                        i.madrid_shop_option = i.madrid_shop_option.split('');
                        i.cuirz_option = i.cuirz_option.split('');
                        i.beazl_option = i.beazl_option.split('');
                        i.kickitshirts_option = i.kickitshirts_option.split('');
                        i.mailloten_option = i.mailloten_option.split('');
                        i.honorjersey_option = i.honorjersey_option.split('');
                        i.nihonbro_option = i.nihonbro_option.split('');
                        i.jleague_shop_option = i.jleague_shop_option.split('');
                        i.top_w_option = i.top_w_option.split('');
                        i.figocalcio_option = i.figocalcio_option.split('');
                    }

                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;

                })

            },

            // 获取站点添加情况
            getSiteCount(){

                var _left1 = 0,_right1 = 0;
                var _left2 = 0,_right2 = 0;
                var _left3 = 0,_right3 = 0;
                var _left4 = 0,_right4 = 0;
                var _left5 = 0,_right5 = 0;
                var _left6 = 0,_right6 = 0;
                var _left7 = 0,_right7 = 0;
                var _left8 = 0,_right8 = 0;
                var _left9 = 0,_right9 = 0;
                var _left10 = 0,_right10 = 0;
                var _left11 = 0,_right11 = 0;
                var _left12 = 0,_right12 = 0;
                var _left13 = 0,_right13 = 0;
                var _left14 = 0,_right14 = 0;

                GetSku().then(res => {

                    for(var i of res.data){
                        i.supermaillot_option = i.supermaillot_option.split('');
                        i.fortmaillot_option = i.fortmaillot_option.split('');
                        i.ligafoot_option = i.ligafoot_option.split('');
                        i.maillottrade_option = i.maillottrade_option.split('');
                        i.madrid_shop_option = i.madrid_shop_option.split('');
                        i.cuirz_option = i.cuirz_option.split('');
                        i.beazl_option = i.beazl_option.split('');
                        i.kickitshirts_option = i.kickitshirts_option.split('');
                        i.mailloten_option = i.mailloten_option.split('');
                        i.honorjersey_option = i.honorjersey_option.split('');
                        i.nihonbro_option = i.nihonbro_option.split('');
                        i.jleague_shop_option = i.jleague_shop_option.split('');
                        i.top_w_option = i.top_w_option.split('');
                        i.figocalcio_option = i.figocalcio_option.split('');
                    }

                    var ABC = res.data;

                    var DEF = [];
                    for(var j of ABC){
                        if(j.add_time > '2023-11-12 00:00:00'){
                            DEF.push(j);
                        }
                    }

                    for(var i of DEF){

                        // supermaillot_option
                        if(i.supermaillot_option[0] == 1){
                            _left1 += 1;
                        }
                        if(i.supermaillot_option[1] == 1){
                            _right1 += 1;
                        }

                        // fortmaillot_option
                        if(i.fortmaillot_option[0] == 1){
                            _left2 += 1;
                        }
                        if(i.fortmaillot_option[1] == 1){
                            _right2 += 1;
                        }

                        // ligafoot_option
                        if(i.ligafoot_option[0] == 1){
                            _left3 += 1;
                        }
                        if(i.ligafoot_option[1] == 1){
                            _right3 += 1;
                        }

                        // maillottrade_option
                        if(i.maillottrade_option[0] == 1){
                            _left4 += 1;
                        }
                        if(i.maillottrade_option[1] == 1){
                            _right4 += 1;
                        }

                        // madrid_shop_option
                        if(i.madrid_shop_option[0] == 1){
                            _left5 += 1;
                        }
                        if(i.madrid_shop_option[1] == 1){
                            _right5 += 1;
                        }

                        // cuirz_option
                        if(i.cuirz_option[0] == 1){
                            _left6 += 1;
                        }
                        if(i.cuirz_option[1] == 1){
                            _right6 += 1;
                        }

                        // beazl_option
                        if(i.beazl_option[0] == 1){
                            _left7 += 1;
                        }
                        if(i.beazl_option[1] == 1){
                            _right7 += 1;
                        }

                        // kickitshirts_option
                        if(i.kickitshirts_option[0] == 1){
                            _left8 += 1;
                        }
                        if(i.kickitshirts_option[1] == 1){
                            _right8 += 1;
                        }

                        // mailloten_option
                        if(i.mailloten_option[0] == 1){
                            _left9 += 1;
                        }
                        if(i.mailloten_option[1] == 1){
                            _right9 += 1;
                        }

                        // honorjersey_option
                        if(i.honorjersey_option[0] == 1){
                            _left10 += 1;
                        }
                        if(i.honorjersey_option[1] == 1){
                            _right10 += 1;
                        }

                        // nihonbro_option
                        if(i.nihonbro_option[0] == 1){
                            _left11 += 1;
                        }
                        if(i.nihonbro_option[1] == 1){
                            _right11 += 1;
                        }

                        // jleague_shop_option
                        if(i.jleague_shop_option[0] == 1){
                            _left12 += 1;
                        }
                        if(i.jleague_shop_option[1] == 1){
                            _right12 += 1;
                        }

                        // top_w_option
                        if(i.top_w_option[0] == 1){
                            _left13 += 1;
                        }
                        if(i.top_w_option[1] == 1){
                            _right13 += 1;
                        }

                        // figocalcio_option
                        if(i.figocalcio_option[0] == 1){
                            _left14 += 1;
                        }
                        if(i.figocalcio_option[1] == 1){
                            _right14 += 1;
                        }
                    }

                    this.supermaillot = _left1 - _right1;
                    this.fortmaillot = _left2 - _right2;
                    this.ligafoot = _left3 - _right3;
                    this.maillottrade = _left4 - _right4;
                    this.madrid_shop = _left5 - _right5;
                    this.cuirz = _left6 - _right6;
                    this.beazl = _left7 - _right7;
                    this.kickitshirts = _left8 - _right8;
                    this.mailloten = _left9 - _right9;
                    this.honorjersey = _left10 - _right10;
                    this.nihonbro = _left11 - _right11;
                    this.jleague_shop = _left12 - _right12;
                    this.top_w = _left13 - _right13;
                    this.figocalcio = _left14 - _right14;

                })

            },

            // 点击新增SKU按钮，打开对话框
            add_sku(){

                this.add_sku_form = {
                    league_name:'',
                    team_name:'',
                    sku:'',
                    product_name:'',
                    shorts:'',
                    socks:'',
                    remarks:'',
                    supermaillot_option:'',
                    fortmaillot_option:'',
                    ligafoot_option:'',
                    maillottrade_option:'',
                    madrid_shop_option:'',
                    cuirz_option:'',
                    beazl_option:'',
                    kickitshirts_option:'',
                    mailloten_option:'',
                    honorjersey_option:'',
                    nihonbro_option:'',
                    jleague_shop_option:'',
                    top_w_option:'',
                    figocalcio_option:''
                };

                this.add_sku_dialog = true;

            },

            // 确定新增SKU
            affirm_add_sku(){

                var params = {
                    league_name:this.add_sku_form.league_name,
                    team_name:this.add_sku_form.team_name,
                    sku:this.add_sku_form.sku,
                    product_name:this.add_sku_form.product_name,
                    shorts:this.add_sku_form.shorts,
                    socks:this.add_sku_form.socks,
                    remarks:this.add_sku_form.remarks,
                    supermaillot_option:this.add_sku_form.supermaillot_option,
                    fortmaillot_option:this.add_sku_form.fortmaillot_option,
                    ligafoot_option:this.add_sku_form.ligafoot_option,
                    maillottrade_option:this.add_sku_form.maillottrade_option,
                    madrid_shop_option:this.add_sku_form.madrid_shop_option,
                    cuirz_option:this.add_sku_form.cuirz_option,
                    beazl_option:this.add_sku_form.beazl_option,
                    kickitshirts_option:this.add_sku_form.kickitshirts_option,
                    mailloten_option:this.add_sku_form.mailloten_option,
                    honorjersey_option:this.add_sku_form.honorjersey_option,
                    nihonbro_option:this.add_sku_form.nihonbro_option,
                    jleague_shop_option:this.add_sku_form.jleague_shop_option,
                    top_w_option:this.add_sku_form.top_w_option,
                    figocalcio_option:this.add_sku_form.figocalcio_option
                }

                params.add_person = window.localStorage.getItem('un');
                params.add_time = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                params.hidden_time = params.add_time;
                params.ispriority = '';
                params.flag = '1';

                if(
                    params.sku == '' || 
                    params.product_name == '' || 
                    params.shorts == '' || 
                    params.socks == '' || 
                    params.supermaillot_option.length == 0 || 
                    params.fortmaillot_option.length == 0 || 
                    params.ligafoot_option.length == 0 || 
                    params.maillottrade_option.length == 0 || 
                    params.madrid_shop_option.length == 0 || 
                    params.cuirz_option.length == 0 || 
                    params.beazl_option.length == 0 || 
                    params.kickitshirts_option.length == 0 || 
                    params.mailloten_option.length == 0 || 
                    params.honorjersey_option.length == 0 || 
                    params.nihonbro_option.length == 0 || 
                    params.jleague_shop_option.length == 0 || 
                    params.top_w_option.length == 0 || 
                    params.figocalcio_option.length == 0 )
                {
                    this.$message({
                        message:'表单数据填写不完整！！！',
                        type:'error'
                    })
                    return false;
                }

                UploadSku(params).then(res => {
                    if(res.code == 200){
                        this.$message({
                            message:res.msg,
                            type:'success'
                        })
                        this.getSiteCount();
                        this.getSku();
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                })

                this.add_sku_dialog = false;

            },

            // 点击修改按钮，打开对话框
            edit_sku(index,row){
                this.edit_sku_form = {
                    league_name:row.league_name,
                    team_name:row.team_name,
                    sku:row.sku,
                    product_name:row.product_name,
                    shorts:row.shorts,
                    socks:row.socks,
                    remarks:row.remarks
                };
                this.edit_sku_dialog = true;
            },

            // 取消修改SKU
            cancel_edit_sku(){
                this.edit_sku_dialog = false;
            },

            // 确定修改SKU
            affirm_edit_sku(){
                var params = {
                    sku:this.edit_sku_form.sku
                }
                GetKey(params).then(res => {
                    if(
                        res[0].league_name === this.edit_sku_form.league_name && 
                        res[0].team_name === this.edit_sku_form.team_name &&
                        res[0].sku === this.edit_sku_form.sku &&
                        res[0].product_name === this.edit_sku_form.product_name &&
                        res[0].shorts === this.edit_sku_form.shorts &&
                        res[0].socks === this.edit_sku_form.socks &&
                        res[0].remarks === this.edit_sku_form.remarks
                    ){
                        this.edit_sku_dialog = false;
                    }else{
                        var NewTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                        var params = {
                            league_name:this.edit_sku_form.league_name,
                            team_name:this.edit_sku_form.team_name,
                            sku:this.edit_sku_form.sku,
                            product_name:this.edit_sku_form.product_name,
                            shorts:this.edit_sku_form.shorts,
                            socks:this.edit_sku_form.socks,
                            remarks:this.edit_sku_form.remarks,
                            hidden_time:NewTime
                        }
                        UpdateSku(params).then(res => {
                            if(res.code == 200){
                                this.edit_sku_dialog = false;
                                this.getSku();
                                this.$message.success(res.msg);
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    }
                })
            },

            // 打开删除SKU对话框
            delete_sku(index,row){
                this.delete_sku_params = {
                    sku:row.sku
                }
                this.delete_sku_dialog = true;
            },

            // 确定删除SKU
            affirm_delete_dialog(){
                this.loading = true;
                DeleteSku(this.delete_sku_params).then(res => {
                    if(res.code == 200){
                        this.$message({
                            message:res.msg,
                            type:'success'
                        })
                        this.getSiteCount();
                        this.getSku();
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                        this.loading = false;
                    }
                })
                this.delete_sku_dialog = false;
            },

            // 打开是否优先添加SKU对话框
            IsPriority(row){
                var NewTime = '';
                if(row.ispriority == '是'){
                    NewTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                }else if(row.ispriority == ''){
                    NewTime = row.add_time;
                }
                this.ispriority_add_sku_params = {
                    sku:row.sku,
                    ispriority:row.ispriority,
                    hidden_time:NewTime
                }
                this.ispriority_add_sku_dialog = true;
            },

            // 取消是否优先添加SKU
            cancel_IsPriority(){
                this.loading = true;
                this.getSku();
                this.ispriority_add_sku_dialog = false;
                this.loading = false;
            },

            // 确定是否优先添加SKU
            affirm_IsPriority(){
                this.loading = true;
                PriorityAddSku(this.ispriority_add_sku_params).then(res => {
                    if(res.code == 200){
                        this.$message({
                            message:res.msg,
                            type:'success'
                        })
                        this.getSku();
                    }else{
                        this.$message({
                            message:res.msg,
                            type:'error'
                        })
                    }
                })
                this.ispriority_add_sku_dialog = false;
            },

            // 查询
            _search(){
                var params = {
                    sku:this.SKU,
                    product_name:this.product_name
                }
                if(params.sku == '' && params.product_name == ''){
                    this.$message.error('查询内容不能为空!!!');
                    return false;
                }else{
                    this.getSku();
                }
            },

            // 重置
            _refresh(){
                this.loading = true;
                this.SKU = '';
                this.product_name = '';
                this.getSku();
            },

            // 打开修改站点选项对话框(修改是否需要添加)
            left($event,row1,row2,A){
                var NewTime = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                this.site_option_params = {
                    sku:row1,
                    hidden_time:NewTime
                }
                this.site_option_params[A] = row2.join('');
                console.log(A);
                console.log(row1,typeof(row1));
                console.log(row2,typeof(row2));
                console.log(this.site_option_params);
                if(row2[0] == '0' && row2[1] == '1'){
                    this.$message.error('修改失败!!!');
                    this.getSku();
                }else{
                    this.site_option_dialog = true;
                }
            },

            // 打开修改站点选项对话框(修改是否已经添加)
            right($event,row1,row2,row3,A){
                this.site_option_params = {
                    sku:row1,
                    hidden_time:row3
                }
                this.site_option_params[A] = row2.join('');
                console.log(A);
                console.log(row1,typeof(row1));
                console.log(row2,typeof(row2));
                console.log(row3,typeof(row3));
                console.log(this.site_option_params);
                if(row2[0] == '0' && row2[1] == '1'){
                    this.$message.error('修改失败!!!');
                    this.getSku();
                }else{
                    this.site_option_dialog = true;
                }
            },

            // 取消修改站点选项
            cancel_site_option(){
                this.loading = true;
                this.getSku();
                this.site_option_dialog = false;
                this.loading = false;
            },

            // 确定修改站点选项
            affirm_site_option(){
                this.site_option_dialog = false;
                this.loading = true;
                EditSite(this.site_option_params).then(res => {
                    if(res.code == 200){
                        this.getSiteCount();
                        this.getSku();
                        this.$message.success(res.msg);
                    }else{
                        this.$message.error(res.msg);
                    }
                })
                
                this.loading = false;
            },

            // 设置每页条数
            handleSizeChange(val) {
                
                this.loading = true;
                this.mrmyts = val;
                var params = {
                    sku:this.SKU,
                    product_name:this.product_name,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }

                SearchSku(params).then(res => {

                    for(var i of res.data){
                        i.supermaillot_option = i.supermaillot_option.split('');
                        i.fortmaillot_option = i.fortmaillot_option.split('');
                        i.ligafoot_option = i.ligafoot_option.split('');
                        i.maillottrade_option = i.maillottrade_option.split('');
                        i.madrid_shop_option = i.madrid_shop_option.split('');
                        i.cuirz_option = i.cuirz_option.split('');
                        i.beazl_option = i.beazl_option.split('');
                        i.kickitshirts_option = i.kickitshirts_option.split('');
                        i.mailloten_option = i.mailloten_option.split('');
                        i.honorjersey_option = i.honorjersey_option.split('');
                        i.nihonbro_option = i.nihonbro_option.split('');
                        i.jleague_shop_option = i.jleague_shop_option.split('');
                        i.top_w_option = i.top_w_option.split('');
                        i.figocalcio_option = i.figocalcio_option.split('');
                    }

                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;

                })

            },

            // 跳转到哪一页
            handleCurrentChange(val) {

                this.loading = true;
                this.currentPage = val;
                var params = {
                    sku:this.SKU,
                    product_name:this.product_name,
                    limit:this.mrmyts,
                    offset:this.currentPage
                }

                SearchSku(params).then(res => {

                    for(var i of res.data){
                        i.supermaillot_option = i.supermaillot_option.split('');
                        i.fortmaillot_option = i.fortmaillot_option.split('');
                        i.ligafoot_option = i.ligafoot_option.split('');
                        i.maillottrade_option = i.maillottrade_option.split('');
                        i.madrid_shop_option = i.madrid_shop_option.split('');
                        i.cuirz_option = i.cuirz_option.split('');
                        i.beazl_option = i.beazl_option.split('');
                        i.kickitshirts_option = i.kickitshirts_option.split('');
                        i.mailloten_option = i.mailloten_option.split('');
                        i.honorjersey_option = i.honorjersey_option.split('');
                        i.nihonbro_option = i.nihonbro_option.split('');
                        i.jleague_shop_option = i.jleague_shop_option.split('');
                        i.top_w_option = i.top_w_option.split('');
                        i.figocalcio_option = i.figocalcio_option.split('');
                    }

                    this.tableData = res.data;
                    this.Total = res.count;
                    this.loading = false;

                })

            },

        },

    };

</script>

<style lang="scss" scoped>

    .top{
        margin-bottom: 1vh;
    }

    .top > div{
        display: inline-block;
    }

</style>